export const SITE_ACCESS_CERTIFIER_TEXT = "site-access-certifier-text";
export const SITE_ACCESS_STAFF_TEXT = "site-access-staff-text";
export const PRIVILEGED_PROVIDER_STAFF_LABEL =
  "site-access-privileged-provider-staff-label";
export const PROVIDER_STAFF_LABEL = "site-access-provider-staff-label";
export const SITE_CERTIFIER_LABEL = "site-access-site-certifier-label";
export const PRIVILEGED_PROVIDER_STAFF_TOOLTIP_TEXT =
  "privileged-provider-staff-tooltip-text";
export const PRIVILEGED_PROVIDER_STAFF_TOOLTIP = "privileged-provider-staff";
